/**
 * Colour for a product label, by its position in the tenant's catalog.
 *
 * The catalog (tenant config `products`, catalog order) decides colours, so
 * the first product is always cyan and the second indigo on every tenant —
 * no product name appears here. A product the catalog does not list (a stale
 * case, a cold catalog) gets a palette colour picked by a stable hash of its
 * name, so the same name always gets the same colour. No product = neutral.
 *
 * DON'T build these class names dynamically: Tailwind only ships classes it
 * finds spelled out in src/.
 */
const PALETTE = [
  { badge: "bg-cyan-100 text-cyan-700", pill: "bg-cyan-50 border-cyan-200 text-cyan-700", text: "text-cyan-700" },
  { badge: "bg-indigo-100 text-indigo-700", pill: "bg-indigo-50 border-indigo-200 text-indigo-700", text: "text-indigo-700" },
  { badge: "bg-emerald-100 text-emerald-700", pill: "bg-emerald-50 border-emerald-200 text-emerald-700", text: "text-emerald-700" },
  { badge: "bg-amber-100 text-amber-700", pill: "bg-amber-50 border-amber-200 text-amber-700", text: "text-amber-700" },
  { badge: "bg-violet-100 text-violet-700", pill: "bg-violet-50 border-violet-200 text-violet-700", text: "text-violet-700" },
  { badge: "bg-rose-100 text-rose-700", pill: "bg-rose-50 border-rose-200 text-rose-700", text: "text-rose-700" },
];

const NEUTRAL = { badge: "bg-gray-100 text-gray-500", pill: "bg-white border-gray-200 text-gray-500", text: "text-gray-500" };

function hash(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

export function productTone(product, products) {
  const name = String(product ?? "").trim();
  if (!name) return NEUTRAL;
  const key = name.toLowerCase();
  const idx = (Array.isArray(products) ? products : []).findIndex((p) => String(p).toLowerCase() === key);
  return PALETTE[(idx >= 0 ? idx : hash(key)) % PALETTE.length];
}
